import request from './request';

export const reqArticleList = params => request({url: '/article/article/', method: 'get', params: params});
export const reqArticleCategorizeList = () => request({url: '/article/categorize/', method: 'get'});
export const reqArticleContent = pk => request({url: `/article/visit/${pk}`, method: 'get'});
export const reqNoticeList = () => request({url: `/article/notice`, method: 'get'});


export const reqCertificateList = params => request({url: '/certificate/certificate/', method: 'get', params: params});
export const reqCertificateCategorizeList = () => request({url: '/certificate/categorize/', method: 'get'});


export const reqDeputyProject = () => request({url: '/project/deputy/', method: 'get'});
export const reqMainProject = () => request({url: '/project/main/', method: 'get'});
export const reqSSVideos = () => request({url: '/project/ssvidoes/', method: 'get'});


export const reqProductList = () => request({url: '/product/product/', method: 'get'});


export const reqBannerList = () => request({url: '/home/banner/', method: 'get'});
export const reqBrandList = () => request({url: '/home/brand/', method: 'get'});
export const reqCustomerList = () => request({url: '/home/customer/', method: 'get'});
export const reqReasonList = () => request({url: '/home/reason/', method: 'get'});

export const reqContactList = () => request({url: '/about/contact/', method: 'get'});
export const reqAboutBannerList = () => request({url: '/about/banner/', method: 'get'});







